import React from 'react';
import { HeartIcon, PaletteIcon, LockIcon, FileTextIcon, GlobeIcon, CreditCardIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { TrustLine } from './TrustLine';
import { LocalCurrencyNote } from './LocalCurrencyNote';
import { closingLines, tomes } from '../data/content';
import { offer } from '../data/offer';
const trust = [{
  icon: LockIcon,
  label: 'Pago seguro'
}, {
  icon: FileTextIcon,
  label: 'Producto 100% digital'
}, {
  icon: GlobeIcon,
  label: 'Compra desde LATAM'
}, {
  icon: CreditCardIcon,
  label: 'Moneda local según país'
}];
export function ClosingSection() {
  return <section aria-labelledby="closing" className="bg-ink px-5 py-20 sm:py-28" data-id="element-26" data-mp="1li1q2qczvvl5">
      <div className="mx-auto max-w-4xl text-center" data-id="element-27" data-mp="1hhhu3q45qy0l">
        <HeartIcon className="mx-auto h-10 w-10 fill-coral text-coral" aria-hidden="true" data-id="element-28" data-mp="1hk3zbj3kt1fn" />
        <h2 id="closing" className="mt-4 text-3xl font-black uppercase leading-tight text-white sm:text-5xl" data-id="element-29" data-mp="1vferupuclagu">
          El próximo «Estoy aburrido» puede ser diferente.
        </h2>

        <ul className="mx-auto mt-10 grid max-w-3xl gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-30" data-mp="22dx48liwow33">
          {closingLines.map((line, i) => {
          const {
            icon: Icon,
            color
          } = tomes[i];
          return <li key={line} className="flex items-center gap-3 rounded-2xl bg-surface px-4 py-4 text-left" data-id="element-31" data-mp="2c98m3cpm2jf2" data-mpi={i}>
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg" style={{
              backgroundColor: color
            }} data-id="element-32" data-mp="2g9sfq6az74wg">
                  <Icon className="h-4 w-4 text-ink" aria-hidden="true" data-id="element-33" data-mp="2q9rnw23hgt8s" />
                </span>
                <span className="text-base font-bold text-cream" data-id="element-34" data-mp="2v0htngftmy40">{line}</span>
              </li>;
        })}
        </ul>

        <p className="mt-10 text-lg text-muted" data-id="element-35" data-mp="2zyt5fwpofiov">No necesitas ideas nuevas todos los días.</p>
        <p className="mt-2 text-2xl font-black uppercase leading-tight text-brand sm:text-4xl" data-id="element-36" data-mp="342r6we2h55l3">
          Necesitas tenerlas listas cuando las necesites.
        </p>

        <div className="mt-14 border-t border-line pt-12" data-id="element-37" data-mp="18y9tvyv1jfd7">
          <p className="flex items-center justify-center gap-2 text-lg font-black uppercase tracking-[0.25em] text-brand" data-id="element-38" data-mp="18yt5kxu3l7is">
            <PaletteIcon className="h-5 w-5" aria-hidden="true" data-id="element-39" data-mp="1iockxtilqj8w" />
            ReadyKit Digital™
          </p>
          <p className="mt-3 text-xl font-black uppercase tracking-wide text-white sm:text-2xl" data-id="element-40" data-mp="1dxw9geycd7p6">Crear. Jugar. Descubrir. Sin pantallas.</p>
          <div className="mt-8" data-id="element-41" data-mp="1sl7j2bayqhmn">
            <p className="text-5xl font-black leading-none text-white" data-id="element-42" data-mp="1somxrd0q5onj">{offer.price}</p>
            <p className="mt-2 text-sm font-black uppercase tracking-wide text-brand" data-id="element-43" data-mp="1nn633z8u2yfe">Precio de lanzamiento</p>
            <div className="mt-6" data-id="element-44" data-mp="21l4agkoqlule">
              <CTAButton href={offer.checkoutUrl} data-id="element-45" data-mp="1wnm4n360nvhm">Quiero mi MegaPack Antipantallas Listo</CTAButton>
            </div>
            <LocalCurrencyNote className="mt-4" data-id="element-46" data-mp="7a8s4qnr315f" />
          </div>
          <div className="mt-5" data-id="element-47" data-mp="2acowtmvndqx">
            <TrustLine items={trust} data-id="element-48" data-mp="2b5ye2d80hcr" />
          </div>
        </div>
      </div>
    </section>;
}